import React from 'react'
import { getHexColor, TwoColorIconProps } from '../utils'

export const NoCreditsIcon: React.FC<TwoColorIconProps> = ({
  size = 24,
  color1 = 'white',
  color2 = 'black',
  className,
  onClick,
}) => {
  const fill = getHexColor(color1)
  const stroke = getHexColor(color2)
  return (
    <svg
      width={size}
      height={size}
      className={className}
      onClick={onClick}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H20C20.55 3 21.0208 3.19583 21.4125 3.5875C21.8042 3.97917 22 4.45 22 5V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4ZM4 19H6V17H4V19ZM18 19H20V17H18V19ZM11 17H13V11H11V17ZM4 15H6V13H4V15ZM18 15H20V13H18V15ZM4 11H6V9H4V11ZM18 11H20V9H18V11ZM12 9C12.2833 9 12.5208 8.90417 12.7125 8.7125C12.9042 8.52083 13 8.28333 13 8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8C11 8.28333 11.0958 8.52083 11.2875 8.7125C11.4792 8.90417 11.7167 9 12 9ZM4 7H6V5H4V7ZM18 7H20V5H18V7ZM8 19H16V5H8V19Z"
        stroke={fill}
      />
      <path d="M3.75 1.875L22.4669 20.5919" stroke={stroke} strokeWidth="2.25" strokeLinecap="round" />
      <path d="M2.25 3.375L20.9669 22.0919" stroke={fill} strokeWidth="2.25" strokeLinecap="round" />
    </svg>
  )
}
